(() => {
  const details = document.querySelector('.ol-contact-widget__details');
  if (!details || details.dataset.initialized) return;
  details.dataset.initialized = 'true';
  const toggle = details.querySelector('summary');
  const storageKey = 'ol-contact-widget-open';
  let saved = null;
  try { saved = sessionStorage.getItem(storageKey); } catch (_) { /* Storage is optional. */ }
  details.open = saved === null ? !window.matchMedia('(max-width: 749px)').matches : saved === 'true';
  const syncLabel = () => toggle.setAttribute('aria-label', details.open ? 'Kontakt mit Dominik minimieren' : 'Kontakt mit Dominik öffnen');
  syncLabel();
  let userToggled = false;
  toggle.addEventListener('click', () => { userToggled = true; });
  details.addEventListener('toggle', () => {
    syncLabel();
    if (userToggled) {
      try { sessionStorage.setItem(storageKey, String(details.open)); } catch (_) { /* Storage is optional. */ }
      userToggled = false;
    }
  });
})();
